
import Vue from 'vue';
import Navbar from './components/Navbar.vue';
import { store } from './store';
import { handleLoginCheck } from './services/loginChecker';

export default Vue.extend({
  components: {
    Navbar
  },
  computed: {
    loading() {
      return store.loading > 0;
    }
  },
  async beforeMount() {
    await handleLoginCheck(this.$router);
  },
})
